/**
 * 订单管理 统计分析
 */
<template>
  <div>

    <el-tabs v-model="activeName" type="border-card" @tab-click="handleClick">
      <el-tab-pane label="科目图表" name="SUBJECT">
        <subject-report v-if="activeName == 'SUBJECT'" ref="SUBJECT" :type="'SUBJECT'"></subject-report>
      </el-tab-pane>
      <el-tab-pane label="地区图表" name="AREA">
        <area-report v-if="activeName == 'AREA'" ref="AREA" :type="'AREA'"></area-report>
      </el-tab-pane>
      <el-tab-pane label="年龄图表" name="AGE">
        <age-report v-if="activeName == 'AGE'" ref="AGE" :type="'AGE'"></age-report>
      </el-tab-pane>
      <el-tab-pane label="营销渠道图表" name="MARKETING_CHANNEL">
        <marketing-report v-if="activeName == 'MARKETING_CHANNEL'" ref="MARKETING_CHANNEL" :type="'MARKETING_CHANNEL'"></marketing-report>
      </el-tab-pane>
    </el-tabs>

<!--    <div class="onlyCss">
      <el-date-picker
        style="position: absolute; top: 2px; left: 2px;"
        size="small"
        v-model="dateValue"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="changeDate('SUBJECT')">
      </el-date-picker>
      <div id="subject" class="twoCss">

      </div>
    </div>
    <div class="onlyCss">
      <div id="area" class="twoCss">

      </div>
    </div>
    <div class="onlyCss">
      <div id="age" class="twoCss">

      </div>
    </div>
    <div class="onlyCss">
      <div id="marketingChannel" class="twoCss">

      </div>
    </div>-->

  </div>
</template>

<script>
import { findReportData } from '../../api/userMG'
import { timestampToTime } from '../../utils/util'
import SubjectReport from './subjectReport'
import AreaReport from './areaReport'
import AgeReport from './ageReport'
import MarketingReport from './marketingReport'

import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      activeName: 'SUBJECT',
      dateValue: '',
      loading: false, //是显示加载
      title: '预览',
      queryParams: {
        startTime: '2023-07-01',
        endTime: '2023-07-24',
        reportType: ''      // SUBJECT,AREA,AGE,MARKETING_CHANNEL
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 科目数据
      subjectAbscissa: [],    // 横坐标
      subjectOrdinate: [],    // 纵坐标

      // 地区数据
      areaAbscissa: [],    // 横坐标
      areaOrdinate: [],    // 纵坐标

      // 年龄数据
      ageAbscissa: [],    // 横坐标
      ageOrdinate: [],    // 纵坐标

      // 营销渠道数据
      marketingChannelAbscissa: [],    // 横坐标
      marketingChannelOrdinate: [],    // 纵坐标
    }
  },
  // 注册组件
  components: {
    Pagination,
    SubjectReport,
    AreaReport,
    AgeReport,
    MarketingReport
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    // this.initData()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    initData() {
      this.getdata('SUBJECT');
      this.getdata('AREA');
      this.getdata('AGE');
      this.getdata('MARKETING_CHANNEL');
    },
    handleClick(tab, event) {

    },
    changeDate(name) {
      this.queryParams.startTime = timestampToTime(this.dateValue[0]).split(' ')[0];
      this.queryParams.endTime = timestampToTime(this.dateValue[1]).split(' ')[0];
      this.getdata(name)
    },
    // 获取图表数据
    getdata(x) {
      this.loading = true
      if (x) {
        this.queryParams.reportType = x;
      }
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      findReportData(JSON.stringify(this.queryParams)).then(res => {
        this.loading = false
        if (res.code != 200) {
          this.$message({
            type: 'info',
            message: res.msg
          })
        } else {
          if (x == 'SUBJECT') {
            this.subjectAbscissa = res.data.abscissa;
            this.subjectOrdinate = res.data.ordinate;

            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById('subject'));

            // 指定图表的配置项和数据
            var option = {
              title: {
                text: '科目报表',
                left: 'center',
                textStyle: {
                  color: '#6cd7d9'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['学生数量'],
                right: 10,
                top: 10,
                align: 'right',
                itemStyle: {
                  color: '#6cd7d9'  // 设置 legend 文字的颜色为红色
                },
              },
              calculable : true,
              xAxis: {
                type : 'category',
                data: res.data.abscissa
              },
              yAxis: {

              },
              series: [
                {
                  name: '学生数量',
                  type: 'bar',
                  data: res.data.ordinate,
                  barWidth: 35,  // 设置柱子的宽度为 20
                  itemStyle: {
                    // 设置每个柱子的样式
                    color: function(params) {
                      // 可以根据数据值动态设置柱子的颜色
                      if (params.value > 30) {
                        return 'red';  // 大于 30 的柱子颜色为红色
                      }
                      return '#6cd7d9';   // 其他柱子颜色为蓝色
                    },
                    // 其他样式设置...
                    barBorderRadius: [6, 6, 0, 0]   // 顶端圆角
                  },
                }
              ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);

          } else if (x == 'AREA') {
            this.areaAbscissa = res.data.abscissa;
            this.areaOrdinate = res.data.ordinate;

            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById('area'));

            // 指定图表的配置项和数据
            var option = {
              title: {
                text: '地区报表',
                left: 'center',
                textStyle: {
                  color: '#6cd7d9'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['学生数量'],
                right: 10,
                top: 10,
                align: 'right',
                itemStyle: {
                  color: '#6cd7d9'  // 设置 legend 文字的颜色为红色
                },
              },
              calculable : true,
              xAxis: {
                type : 'category',
                data: res.data.abscissa
              },
              yAxis: {

              },
              series: [
                {
                  name: '学生数量',
                  type: 'bar',
                  data: res.data.ordinate,
                  barWidth: 35,  // 设置柱子的宽度为 20
                  itemStyle: {
                    // 设置每个柱子的样式
                    color: function(params) {
                      // 可以根据数据值动态设置柱子的颜色
                      if (params.value > 30) {
                        return 'red';  // 大于 30 的柱子颜色为红色
                      }
                      return '#6cd7d9';   // 其他柱子颜色为蓝色
                    },
                    // 其他样式设置...
                    barBorderRadius: [6, 6, 0, 0]   // 顶端圆角
                  },
                }
              ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);

          } else if (x == 'AGE') {
            this.ageAbscissa = res.data.abscissa;
            this.ageOrdinate = res.data.ordinate;

            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById('age'));

            // 指定图表的配置项和数据
            var option = {
              title: {
                text: '年龄报表',
                left: 'center',
                textStyle: {
                  color: '#6cd7d9'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['学生数量'],
                right: 10,
                top: 10,
                align: 'right',
                itemStyle: {
                  color: '#6cd7d9'  // 设置 legend 文字的颜色为红色
                },
              },
              calculable : true,
              xAxis: {
                type : 'category',
                data: res.data.abscissa
              },
              yAxis: {

              },
              series: [
                {
                  name: '学生数量',
                  type: 'bar',
                  data: res.data.ordinate,
                  barWidth: 35,  // 设置柱子的宽度为 20
                  itemStyle: {
                    // 设置每个柱子的样式
                    color: function(params) {
                      // 可以根据数据值动态设置柱子的颜色
                      if (params.value > 30) {
                        return 'red';  // 大于 30 的柱子颜色为红色
                      }
                      return '#6cd7d9';   // 其他柱子颜色为蓝色
                    },
                    // 其他样式设置...
                    barBorderRadius: [6, 6, 0, 0]   // 顶端圆角
                  },
                }
              ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);

          } else if (x == 'MARKETING_CHANNEL') {
            this.marketingChannelAbscissa = res.data.abscissa;
            this.marketingChannelOrdinate = res.data.ordinate;

            // 基于准备好的dom，初始化echarts实例
            var myChart = this.$echarts.init(document.getElementById('marketingChannel'));

            // 指定图表的配置项和数据
            var option = {
              title: {
                text: '营销渠道报表',
                left: 'center',
                textStyle: {
                  color: '#6cd7d9'
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              legend: {
                data: ['学生数量'],
                right: 10,
                top: 10,
                align: 'right',
                itemStyle: {
                  color: '#6cd7d9'  // 设置 legend 文字的颜色为红色
                },
              },
              calculable : true,
              xAxis: {
                type : 'category',
                data: res.data.abscissa
              },
              yAxis: {

              },
              series: [
                {
                  name: '学生数量',
                  type: 'bar',
                  data: res.data.ordinate,
                  barWidth: 35,  // 设置柱子的宽度为 20
                  itemStyle: {
                    // 设置每个柱子的样式
                    color: function(params) {
                      // 可以根据数据值动态设置柱子的颜色
                      if (params.value > 30) {
                        return 'red';  // 大于 30 的柱子颜色为红色
                      }
                      return '#6cd7d9';   // 其他柱子颜色为蓝色
                    },
                    // 其他样式设置...
                    barBorderRadius: [6, 6, 0, 0]   // 顶端圆角
                  },
                }
              ]
            };

            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);

          }
        }
      })
      .catch(err => {
        this.loading = false
        this.$message.error('加载失败，请稍后再试！')
      })
    },
    // 搜索事件
    search() {
      this.getdata()
    },
  }
}
</script>

<style scoped>
::v-deep .el-card__body, .el-main {
  padding: 0px !important;
}
.container {
  display: flex; /* 使用 flexbox 布局 */
  flex-wrap: wrap; /* 超出容器宽度时换行 */
}
.onlyCss {
  position: relative;
  flex:  0 0 auto;
  white-space: nowrap; /* 不换行显示内容 */
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48%;
  height: 42vh;
  background-color: #f6f6f6;
  border-right: 8px !important;
  margin: 10px;
}
.twoCss {
  width: 80%;
  height: 80%;
}

</style>







// WEBPACK FOOTER //
// src/views/report/reportChart.vue